// document.addEventListener('DOMContentLoaded', function () {

  const variantSelects = document.querySelectorAll('variant-selects');

  variantSelects.forEach(function (variantSelect) {

    const swatchContainer = variantSelect.querySelector('.product-form__input--color');
    const leftButton = variantSelect.querySelector('.swatch-navigation-wrapper[navigation="left"]');
    const rightButton = variantSelect.querySelector('.swatch-navigation-wrapper[navigation="right"]');

    if (!swatchContainer || !leftButton || !rightButton) return;

    const scrollAmount = 250;

    function updateNavigation() {
      const maxScroll = swatchContainer.scrollWidth - swatchContainer.clientWidth;

      // Left button
      if (swatchContainer.scrollLeft <= 5) {
        leftButton.classList.remove('star-show');
      } else {
        leftButton.classList.add('star-show');
      }

      // Right button
      if (swatchContainer.scrollLeft >= maxScroll - 5) {
        rightButton.classList.remove('star-show');
      } else {
        rightButton.classList.add('star-show');
      }
    }

    // Scroll right
    rightButton.addEventListener('click', function () {
      swatchContainer.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    });

    // Scroll left
    leftButton.addEventListener('click', function () {
      swatchContainer.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });
    });

    // Update buttons while scrolling
    swatchContainer.addEventListener('scroll', updateNavigation);

    // Update on resize
    window.addEventListener('resize', updateNavigation);

    // Initial state
    updateNavigation();
  });

// });